'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3() {
}
export { $c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 as $c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 };
$p = $c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3;
/** @constructor */
function $h_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3() {
}
export { $h_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 as $h_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 };
$h_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3.prototype = $p;
$p.Ow = (function(x) {
  return ((x !== null) || false);
});
$p.NS = (function(x, default$1) {
  return ((x !== null) ? (x.bU($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_System$Streams$().bJ), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_CallbackTo($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Ljapgolly_scalajs_react_package$().ao.ah)) : default$1.d(x));
});
$p.Q = (function(x) {
  return this.Ow(x);
});
$p.N = (function(x, default$1) {
  return this.NS(x, default$1);
});
var $d_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3, "mealorama.pages.RecipeCalendarPage$Backend$$anon$3", ({
  Lj: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 as $d_Lmealorama_pages_RecipeCalendarPage$Backend$$anon$3 };
//# sourceMappingURL=mealorama.pages.-Recipe-Calendar-Page$-Backend$$anon$3.js.map
